import { render, staticRenderFns } from "./SetDatasource.vue?vue&type=template&id=3aff5edc&scoped=true"
import script from "./SetDatasource.vue?vue&type=script&lang=js"
export * from "./SetDatasource.vue?vue&type=script&lang=js"
import style0 from "./SetDatasource.vue?vue&type=style&index=0&id=3aff5edc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aff5edc",
  null
  
)

export default component.exports